import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";
import { Calendar } from "@phosphor-icons/react";

export default function AdminExports() {
  const [rows, setRows] = useState([]);
  const [running, setRunning] = useState(false);
  const load = () => api.get("/admin/exports").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const runNow = async () => {
    setRunning(true);
    try {
      const { data } = await api.post("/admin/exports/run");
      toast.success(`Export done · ${data.signups_count} signups · ${data.leads_count} leads`);
      load();
    } catch (e) { toast.error(apiError(e)); }
    setRunning(false);
  };

  return (
    <div>
      <div className="border-b border-ink pb-8">
        <div className="flex items-end justify-between flex-wrap gap-3">
          <div>
            <div className="label-mono">Admin · № 06</div>
            <h1 className="mt-3 font-display font-black text-4xl md:text-5xl tracking-tightest text-ink leading-[1]" data-testid="admin-exports-title">
              EOD exports.
            </h1>
            <p className="mt-3 text-ink/65 max-w-xl">
              Auto-runs at 23:59 Asia/Kolkata. CSVs stored at <code className="font-mono text-xs bg-surface-alt px-1.5 py-0.5">/app/backend/exports/</code>.
            </p>
          </div>
          <Button onClick={runNow} disabled={running} data-testid="export-run-btn">
            <Calendar className="w-4 h-4 mr-1.5" /> {running ? "Running…" : "Run export now"}
          </Button>
        </div>
      </div>

      <div className="mt-8 border border-rule bg-white overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-ink">
              <TableHead className="label-mono">Run date</TableHead>
              <TableHead className="label-mono">Signups</TableHead>
              <TableHead className="label-mono">Leads</TableHead>
              <TableHead className="label-mono">Files</TableHead>
              <TableHead className="label-mono">Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center text-ink/40 py-16">
                No exports yet. Click "Run export now" to generate one.
              </TableCell></TableRow>
            )}
            {rows.map((r) => (
              <TableRow key={r.id} className="hover:bg-surface-hover">
                <TableCell className="font-medium font-mono tabular">{r.run_date}</TableCell>
                <TableCell className="font-mono tabular">{r.signups_count}</TableCell>
                <TableCell className="font-mono tabular">{r.leads_count}</TableCell>
                <TableCell className="font-mono text-xs text-ink/60">
                  {(r.file_urls || []).map((f) => f.split("/").pop()).join(" · ") || "—"}
                </TableCell>
                <TableCell className="font-mono text-xs text-ink/60">{(r.created_at || "").slice(0, 16).replace("T", " ")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
